import { Component } from '@angular/core';

@Component({
  selector: 'nns-note-encrypted',
  template: `
    <div class="nns-encrypted-content" flex layout="column" layout-align="center center">
      <div class="nns-encrypted-icon" flex="none">
        <nns-icon icon="encrypted" flex="none"></nns-icon>
      </div>
      <div class="nns-encrypted-title" flex="none">Note is encrypted</div>
      <div class="nns-encrypted-text" flex="none">If you need access, please contact the owner of this Note.</div>
    </div>
  `,
  styles: [`
    .nns-encrypted-content {
      text-align: center;
      padding: 16px;
    }
    .nns-encrypted-icon {
      padding: 0 0 24px 0;
    }
    .nns-encrypted-title {
      font-size: 24px;
      font-weight: bold;
      line-height: 1.4;
      padding: 0 0 8px 0;
    }

    :host-context(.nns-theme-night) {
      background:#2f3737;
    }
  `]
})

export class NoteEncryptedComponent {
  constructor() {
    return;
  }
}
